import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_workbox_999ef51e from 'nuxt_plugin_workbox_999ef51e' // Source: ./workbox.js (mode: 'client')
import nuxt_plugin_nuxticons_51c7bcd3 from 'nuxt_plugin_nuxticons_51c7bcd3' // Source: ./nuxt-icons.js (mode: 'all')
import nuxt_plugin_plugin_5449a762 from 'nuxt_plugin_plugin_5449a762' // Source: ./vuetify/plugin.js (mode: 'all')
import nuxt_plugin_pluginutils_19b30946 from 'nuxt_plugin_pluginutils_19b30946' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_2f165d11 from 'nuxt_plugin_pluginrouting_2f165d11' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_b6dde004 from 'nuxt_plugin_pluginmain_b6dde004' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_axios_01622195 from 'nuxt_plugin_axios_01622195' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_airbrakenuxt_dfed9440 from 'nuxt_plugin_airbrakenuxt_dfed9440' // Source: ../plugins/airbrake-nuxt.client (mode: 'client')
import nuxt_plugin_airbrakenuxt_aa0f1d50 from 'nuxt_plugin_airbrakenuxt_aa0f1d50' // Source: ../plugins/airbrake-nuxt.server (mode: 'server')
import nuxt_plugin_axios_3566aa80 from 'nuxt_plugin_axios_3566aa80' // Source: ../plugins/axios (mode: 'all')
import nuxt_plugin_bbob_6a7e7a89 from 'nuxt_plugin_bbob_6a7e7a89' // Source: ../plugins/bbob (mode: 'all')
import nuxt_plugin_components_efe3de26 from 'nuxt_plugin_components_efe3de26' // Source: ../plugins/components.client (mode: 'client')
import nuxt_plugin_filters_98405076 from 'nuxt_plugin_filters_98405076' // Source: ../plugins/filters (mode: 'all')
import nuxt_plugin_highcharts_7c46c66a from 'nuxt_plugin_highcharts_7c46c66a' // Source: ../plugins/highcharts.js (mode: 'all')
import nuxt_plugin_i18n_6a80ea94 from 'nuxt_plugin_i18n_6a80ea94' // Source: ../plugins/i18n (mode: 'all')
import nuxt_plugin_veevalidate_6e5ad03a from 'nuxt_plugin_veevalidate_6e5ad03a' // Source: ../plugins/vee-validate (mode: 'all')
import nuxt_plugin_vue2editor_4a7b6e7e from 'nuxt_plugin_vue2editor_4a7b6e7e' // Source: ../plugins/vue2-editor.client (mode: 'client')
import nuxt_plugin_vuexroutersync_91788f0c from 'nuxt_plugin_vuexroutersync_91788f0c' // Source: ../plugins/vuex-router-sync (mode: 'all')
import nuxt_plugin_vuevirtualscroller_3adf1299 from 'nuxt_plugin_vuevirtualscroller_3adf1299' // Source: ../plugins/vue-virtual-scroller (mode: 'all')
import nuxt_plugin_vuetify_165b1c58 from 'nuxt_plugin_vuetify_165b1c58' // Source: ../plugins/vuetify (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":false,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule
const baseStoreOptions = { preserveState: process.client }

function registerModule (path, rawModule, options = {}) {
  return originalRegisterModule.call(this, path, rawModule, { ...baseStoreOptions, ...options })
}

async function createApp(ssrContext, config = {}) {
  const router = await createRouter(ssrContext)

  const store = createStore(ssrContext)
  // Add this.$router into store actions/mutations
  store.$router = router

  // Fix SSR caveat https://github.com/nuxt/nuxt.js/issues/3757#issuecomment-414689141
  store.registerModule = registerModule

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"htmlAttrs":{"dir":"ltr","lang":"en"},"titleTemplate":"%s - sas-backoffice-frontend","title":"sas-backoffice-frontend","meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1"},{"hid":"description","name":"description","content":"Backoffice"},{"hid":"mobile-web-app-capable","name":"mobile-web-app-capable","content":"yes"},{"hid":"apple-mobile-web-app-title","name":"apple-mobile-web-app-title","content":"sas-backoffice-frontend"},{"hid":"author","name":"author","content":"MathieuDerelle"},{"hid":"theme-color","name":"theme-color","content":"#fff"},{"hid":"og:type","name":"og:type","property":"og:type","content":"website"},{"hid":"og:title","name":"og:title","property":"og:title","content":"sas-backoffice-frontend"},{"hid":"og:site_name","name":"og:site_name","property":"og:site_name","content":"sas-backoffice-frontend"},{"hid":"og:description","name":"og:description","property":"og:description","content":"Backoffice"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Ffonts.googleapis.com\u002Fcss?family=Roboto:100,300,400,500,700,900&display=swap"},{"rel":"stylesheet","type":"text\u002Fcss","href":"https:\u002F\u002Fcdn.jsdelivr.net\u002Fnpm\u002F@mdi\u002Ffont@latest\u002Fcss\u002Fmaterialdesignicons.min.css"},{"rel":"manifest","href":"\u002F_nuxt\u002Fmanifest.f82a5aec.json"},{"rel":"shortcut icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_64.5f6a36.png"},{"rel":"apple-touch-icon","href":"\u002F_nuxt\u002Ficons\u002Ficon_512.5f6a36.png","sizes":"512x512"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (process.client && typeof nuxt_plugin_workbox_999ef51e === 'function') {
    await nuxt_plugin_workbox_999ef51e(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxticons_51c7bcd3 === 'function') {
    await nuxt_plugin_nuxticons_51c7bcd3(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_5449a762 === 'function') {
    await nuxt_plugin_plugin_5449a762(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_19b30946 === 'function') {
    await nuxt_plugin_pluginutils_19b30946(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_2f165d11 === 'function') {
    await nuxt_plugin_pluginrouting_2f165d11(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_b6dde004 === 'function') {
    await nuxt_plugin_pluginmain_b6dde004(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_01622195 === 'function') {
    await nuxt_plugin_axios_01622195(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_airbrakenuxt_dfed9440 === 'function') {
    await nuxt_plugin_airbrakenuxt_dfed9440(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_airbrakenuxt_aa0f1d50 === 'function') {
    await nuxt_plugin_airbrakenuxt_aa0f1d50(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_3566aa80 === 'function') {
    await nuxt_plugin_axios_3566aa80(app.context, inject)
  }

  if (typeof nuxt_plugin_bbob_6a7e7a89 === 'function') {
    await nuxt_plugin_bbob_6a7e7a89(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_components_efe3de26 === 'function') {
    await nuxt_plugin_components_efe3de26(app.context, inject)
  }

  if (typeof nuxt_plugin_filters_98405076 === 'function') {
    await nuxt_plugin_filters_98405076(app.context, inject)
  }

  if (typeof nuxt_plugin_highcharts_7c46c66a === 'function') {
    await nuxt_plugin_highcharts_7c46c66a(app.context, inject)
  }

  if (typeof nuxt_plugin_i18n_6a80ea94 === 'function') {
    await nuxt_plugin_i18n_6a80ea94(app.context, inject)
  }

  if (typeof nuxt_plugin_veevalidate_6e5ad03a === 'function') {
    await nuxt_plugin_veevalidate_6e5ad03a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vue2editor_4a7b6e7e === 'function') {
    await nuxt_plugin_vue2editor_4a7b6e7e(app.context, inject)
  }

  if (typeof nuxt_plugin_vuexroutersync_91788f0c === 'function') {
    await nuxt_plugin_vuexroutersync_91788f0c(app.context, inject)
  }

  if (typeof nuxt_plugin_vuevirtualscroller_3adf1299 === 'function') {
    await nuxt_plugin_vuevirtualscroller_3adf1299(app.context, inject)
  }

  if (typeof nuxt_plugin_vuetify_165b1c58 === 'function') {
    await nuxt_plugin_vuetify_165b1c58(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // If server-side, wait for async component to be resolved first
  if (process.server && ssrContext && ssrContext.url) {
    await new Promise((resolve, reject) => {
      router.push(ssrContext.url, resolve, (err) => {
        // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
        if (!err._isRouter) return reject(err)
        if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

        // navigated to a different route in router guard
        const unregister = router.afterEach(async (to, from) => {
          ssrContext.url = to.fullPath
          app.context.route = await getRouteData(to)
          app.context.params = to.params || {}
          app.context.query = to.query || {}
          unregister()
          resolve()
        })
      })
    })
  }

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
